var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1 0C15.1343 0 16.1263 0.410892 16.8577 1.14228C17.5891 1.87368 18 2.86566 18 3.9V4.1076L22.6368 1.326C22.7734 1.24403 22.9292 1.19976 23.0885 1.19772C23.2478 1.19569 23.4047 1.23596 23.5433 1.31441C23.6819 1.39287 23.7973 1.50671 23.8775 1.64431C23.9577 1.7819 24 1.93832 24 2.0976V15.9C24 16.0593 23.9577 16.2157 23.8775 16.3533C23.7973 16.4909 23.6819 16.6047 23.5433 16.6832C23.4047 16.7616 23.2478 16.8019 23.0885 16.7999C22.9292 16.7978 22.7734 16.7536 22.6368 16.6716L18 13.89V14.1C18 15.1343 17.5891 16.1263 16.8577 16.8577C16.1263 17.5891 15.1343 18 14.1 18H3.9C2.86566 18 1.87368 17.5891 1.14228 16.8577C0.410892 16.1263 0 15.1343 0 14.1V3.9C0 2.86566 0.410892 1.87368 1.14228 1.14228C1.87368 0.410892 2.86566 0 3.9 0H14.1ZM14.1 1.8H3.9C3.34305 1.8 2.8089 2.02125 2.41508 2.41508C2.02125 2.8089 1.8 3.34305 1.8 3.9V14.1C1.8 15.2592 2.7408 16.2 3.9 16.2H14.1C14.657 16.2 15.1911 15.9788 15.5849 15.5849C15.9788 15.1911 16.2 14.657 16.2 14.1V3.9C16.2 3.34305 15.9788 2.8089 15.5849 2.41508C15.1911 2.02125 14.657 1.8 14.1 1.8ZM22.2 3.6876L18 6.2088V11.79L22.2 14.31V3.6876Z",
    fill: "#ABB5BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCall);
export default __webpack_public_path__ + "static/media/videoCall.7d23a7ae7e65eb256c8ea7fd45422a9a.svg";
export { ForwardRef as ReactComponent };